// src/components/home/HomeTrustStrip.jsx

import React from "react";
import "./css/HomeTrustStrip.css";

const HomeTrustStrip = () => {
  return (
    <section className="home-trust-strip">

      <div className="home-container home-trust-grid">

        <div className="home-trust-item">
          <strong>500+</strong>
          <span>Patients Treated</span>
        </div>

        <div className="home-trust-item">
          <strong>8</strong>
          <span>Research Articles</span>
        </div>

        <div className="home-trust-item">
          <strong>80+</strong>
          <span>Seminars &amp; Conferences</span>
        </div>

        <div className="home-trust-item">
          <strong>6+</strong>
          <span>Years of Experience</span>
        </div>

      </div>

    </section>
  );
};

export default HomeTrustStrip;